import React from 'react';
import { PickOrder } from '../pickPackTypes';
import { PriorityBadge } from './PriorityBadge';
import { StatusBadge } from './StatusBadge';
import styles from './OrdersTable.module.css';

interface OrdersTableProps {
  orders: PickOrder[];
  onSelectOrder: (order: PickOrder) => void;
}

export const OrdersTable: React.FC<OrdersTableProps> = ({ orders, onSelectOrder }) => {
  const renderActionButton = (order: PickOrder) => {
    switch (order.status) {
      case 'Pending':
        return (
          <button className={styles.btnStartPicking} onClick={() => onSelectOrder(order)}>
            Start Picking
          </button>
        );
      case 'Picking':
        return (
          <button className={styles.btnContinue} onClick={() => onSelectOrder(order)}>
            Continue
          </button>
        );
      case 'Packed':
        return (
          <button className={styles.btnViewDetails} onClick={() => onSelectOrder(order)}>
            View Details
          </button>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>Orders to Pick</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Order #</th>
              <th>Customer Name</th>
              <th>Priority</th>
              <th>Items Count</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id}>
                <td className={styles.orderNumber}>{order.orderNumber}</td>
                <td>{order.customerName}</td>
                <td>
                  <PriorityBadge priority={order.priority} />
                </td>
                <td className={styles.itemsCount}>{order.itemsCount} Items</td>
                <td>
                  <StatusBadge status={order.status} />
                </td>
                <td>{renderActionButton(order)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
